import React, { createContext, useState } from 'react';
// Components
import Image from '../Image';
import RichTextRenderer from '../richTextRenderer';
import InternalExternalLink from '../Link';
// Interfaces
import { Card as CardInterface } from '../../interfaces/card';

const ParentContext = createContext(false);

function Card({ card, columnSpan }: { card: CardInterface; columnSpan?: number }) {
  const { cardType, cardAlignment, cardSize, fullHeight, link, image, body, extraClasses } = card;

  const cardTypeHandler = (type: string) => {
    switch (type) {
      case 'Feature':
        return 'cl-card--feature';
      case 'Product':
        return 'cl-card--product';
      case 'FAQ':
        return 'cl-card--faq';
      case 'Pricing':
        return 'cl-card--pricing';
      case 'Pricing Featured':
        return 'cl-card--pricing cl-card--pricing-featured';
      case 'Pricing Extras':
        return 'cl-card--pricing-extras';
      case 'Rating':
        return 'cl-card--rating';
      case 'Integration':
        return 'cl-card--integration';
      case 'Blockquote':
        return 'cl-card--blockquote';
      case 'Numbered':
        return 'cl-card--numbered';
      case 'User':
        return 'cl-card--user';
      case 'Info':
        return 'cl-card--info';
      case 'Checkmark':
        return 'cl-card--checkmark';
      case 'Xmark':
        return 'cl-card--xmark';
      default:
        return '';
    }
  };

  const WrapperComponent = link ? InternalExternalLink : 'div';

  const [isHovered, setIsHovered] = useState(false);

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <ParentContext.Provider value={isHovered}>
      <WrapperComponent
        onMouseEnter={handleHover}
        onMouseLeave={handleMouseLeave}
        className={`cl-card ${cardTypeHandler(cardType)} ${
          cardAlignment ? `cl-card--${cardAlignment.toLowerCase()}` : ''
        } ${cardSize ? `cl-card--${cardSize}` : ''} ${
          fullHeight ? 'cl-card--full-height' : ''
        } self-start ${extraClasses ? extraClasses : ''} ${
          link ? 'cl-card__link' : ''
        } col-span-4 md:col-span-2 ${columnSpan ? `lg:col-span-${columnSpan}` : ''}`}
        link={link}
        aria-label={link ? 'card link' : ''}
      >
        {image && (
          <div className='cl-card__image'>
            <Image data={image} />
          </div>
        )}
        {body && (
          <div className='cl-card__body'>
            <RichTextRenderer text={body} />
          </div>
        )}
      </WrapperComponent>
    </ParentContext.Provider>
  );
}

export default Card;
export { ParentContext };
